export default __webpack_public_path__ + "static/media/manager.c69c03fa.png";